import {FC, useState} from "react";
import {ICurriculumItemEntity, ILessonEntity, corePaths} from "@buildwitt/shapeshift-types";
import {Box, BoxProps, Button, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {APIState} from "@buildwitt/shapeshift-identity";
import ModuleTypeSelect from "@/components/admin/select/ModuleTypeSelect";
import { AdminLessonPageContent } from "../AdminLessonPageContent";
import { AdminQuizPageContent } from "../../Pages/Quizzes/AdminQuizPageContent";
import { AdminFormContainer, IProps as AdminFormContainerProps } from "../AdminFormContainer";

export interface ICustomProps {
	onSubmit: (e: ICurriculumItemEntity & {id: number, title: string, slug: string}) => void,
	typeFilter?: string,
	lessonId?: number,
	onCancel?: () => void,
	onDeleteResponse?: (response: APIState<ILessonEntity>) => void
}

export type IProps = ICustomProps & Omit<BoxProps, "onSubmit">

const useStyles = makeStyles()(
	(_theme) => ({
		courseCurriculumNewModuleForm: {
			borderRadius: "10px",
			position: "relative"
		},
		loading: {
			position: "absolute",
			left: 0,
			top: 0,
			right: 0,
			bottom: 0,
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			textAlign: "center"
		},
		confirmBtn: {
			color: "black"
		}
	})
);

const CourseCurriculumNewModuleForm: FC<IProps> = ({onSubmit, typeFilter, lessonId, onCancel, onDeleteResponse, ...boxProps}) => {
	const {classes} = useStyles();
	const [moduleType, setModuleType] = useState<string | undefined>(typeFilter);

	return (
		<Box className={classes.courseCurriculumNewModuleForm} {...boxProps}>
			{!typeFilter && <ModuleTypeSelect
				autoSelectFirst
				value={moduleType}
				onChange={e => setModuleType(e)}
			/>}
			<Box padding={2}></Box>
			{moduleType === corePaths.lesson && <AdminLessonPageContent
				lessonId={lessonId}
				onDeleteResponse={onDeleteResponse}
				componentOverrides={{
					adminFormContainer: ({entity, disablePublish, ...containerProps}: AdminFormContainerProps<ILessonEntity, "lesson"> & {disablePublish?: boolean}) => {
						return <AdminFormContainer<ILessonEntity, "lesson"> 
							{...containerProps} entity={entity} 
							disablePublish={disablePublish}
							rootSlug="/admin/lessons" 
							componentOverrides={{
								saveDraftButton: (e) => <Button {...e} className={classes.confirmBtn} variant="contained">Save as Draft</Button>,
								cancelButton: onCancel ? (e) => <Button {...e} onClick={onCancel}>Cancel</Button> : undefined
							}}
						/>
					}, 
					adminHeader: () => <></>
				}}
				onSaveResponse={e => {
					// Always add lesson to curriculum when saved (draft or published), then close modal
					if (!e.isLoading && e.data) {
						onSubmit({...e.data, type: corePaths["lesson"]});
					}
				}}
			/>}

			{moduleType === corePaths.quiz && <AdminQuizPageContent
				onSaveResponse={e => (!e.isLoading && e.data) && onSubmit({...e.data, type: corePaths["quiz"]})}
			/>}
		</Box>
	)
}

export default CourseCurriculumNewModuleForm;